import { render, staticRenderFns } from "./createCommunity.vue?vue&type=template&id=090a850d&scoped=true&"
import script from "./createCommunity.vue?vue&type=script&lang=js&"
export * from "./createCommunity.vue?vue&type=script&lang=js&"
import style0 from "./createCommunity.vue?vue&type=style&index=0&id=090a850d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a850d",
  null
  
)

export default component.exports